import { render, staticRenderFns } from "./AnnouncementShort.vue?vue&type=template&id=1ade45a4&scoped=true"
import script from "./AnnouncementShort.vue?vue&type=script&lang=js"
export * from "./AnnouncementShort.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementShort.vue?vue&type=style&index=0&id=1ade45a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ade45a4",
  null
  
)

export default component.exports